<template>
  <transition name="save-bar">
    <div v-if="dirty || saving" class="save-bar" role="region" :aria-label="$t('satellites.form.unsaved')">
      <div class="save-bar__inner">
        <span class="save-bar__text">
          <span class="sat-dot _warn"></span>
          {{ message || $t("satellites.form.unsaved") }}
        </span>
        <div class="save-bar__actions">
          <button type="button" class="btn _bg-gray" :disabled="saving" @click="$emit('discard')">{{ $t("satellites.form.discard") }}</button>
          <button type="button" class="btn _bg-green sat-btn-inline" :disabled="saving || invalid" @click="$emit('save')">
            <img v-if="saving" src="@/assets/images/rolling-button.svg" class="loader-button" alt="" />
            {{ saveLabel || $t("save") }}
          </button>
        </div>
      </div>
    </div>
  </transition>
</template>
<script>
// Sticky bar of a form page: appears once the form differs from what is saved. Ctrl/Cmd+S saves.
export default {
  name: "SaveBar",
  props: {
    dirty: {
      type: Boolean,
      required: true,
    },
    saving: {
      type: Boolean,
      default: false,
    },
    invalid: {
      type: Boolean,
      default: false,
    },
    message: {
      type: String,
      default: "",
    },
    saveLabel: {
      type: String,
      default: "",
    },
  },
  mounted() {
    window.addEventListener("keydown", this.onKeydown);
  },
  beforeDestroy() {
    window.removeEventListener("keydown", this.onKeydown);
  },
  methods: {
    onKeydown(event) {
      if ((event.metaKey || event.ctrlKey) && event.key === "s" && this.dirty && !this.saving && !this.invalid) {
        event.preventDefault();
        this.$emit("save");
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.save-bar {
  position: sticky;
  bottom: 16px;
  z-index: 20;
  margin-top: 24px;
}

.save-bar__inner {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  padding: 12px 14px 12px 20px;
  border: 1px solid var(--sat-border);
  border-radius: 14px;
  background: var(--sat-card);
  box-shadow: var(--sat-shadow);
}

.save-bar__text {
  display: inline-flex;
  align-items: center;
  gap: 10px;
  font-size: 14px;
  font-weight: 600;
  color: var(--sat-text);
}

.save-bar__actions {
  display: flex;
  gap: 10px;

  .btn {
    height: 40px;
  }
}

.save-bar-enter-active,
.save-bar-leave-active {
  transition: opacity 0.2s, transform 0.2s;
}

.save-bar-enter,
.save-bar-leave-to {
  opacity: 0;
  transform: translateY(12px);
}
</style>
